(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'Kermit-kermit-core'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'Kermit-kermit-core'.");
    }
    globalThis['Kermit-kermit-core'] = factory(typeof globalThis['Kermit-kermit-core'] === 'undefined' ? {} : globalThis['Kermit-kermit-core'], globalThis['kotlin-kotlin-stdlib']);
  }
}(function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.eh;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var VOID = kotlin_kotlin.$_$.d;
  var println = kotlin_kotlin.$_$.de;
  var printStackTrace = kotlin_kotlin.$_$.wo;
  var toList = kotlin_kotlin.$_$.lc;
  var listOf = kotlin_kotlin.$_$.sa;
  var toString = kotlin_kotlin.$_$.hh;
  var hashCode = kotlin_kotlin.$_$.bg;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var equals = kotlin_kotlin.$_$.sf;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.w4;
  var charSequenceLength = kotlin_kotlin.$_$.lf;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var getStringHashCode = kotlin_kotlin.$_$.ag;
  var Enum = kotlin_kotlin.$_$.en;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var stackTraceToString = kotlin_kotlin.$_$.yo;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.uo;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(BaseLogger, 'BaseLogger');
  initMetadataForClass(LogWriter, 'LogWriter');
  initMetadataForClass(CommonWriter, 'CommonWriter', CommonWriter, LogWriter);
  initMetadataForClass(StaticConfig, 'StaticConfig', StaticConfig);
  function formatSeverity(severity) {
    return severity.toString() + ':';
  }
  function formatTag(tag) {
    return '(' + _Tag___get_tag__impl__7z9hd6(tag) + ')';
  }
  function formatMessage(severity, tag, message) {
    var tmp;
    if (severity == null) {
      var tmp_0 = tag;
      tmp = (tmp_0 == null ? null : new Tag(tmp_0)) == null;
    } else {
      tmp = false;
    }
    if (tmp) {
      return _Message___get_message__impl__3t69n4(message);
    }
    var sb = StringBuilder_init_$Create$();
    if (!(severity == null)) {
      sb.q(this.jv9(severity)).q(' ');
    }
    var tmp_1;
    var tmp_2 = tag;
    if (!((tmp_2 == null ? null : new Tag(tmp_2)) == null)) {
      // Inline function 'kotlin.text.isNotEmpty' call
      var this_0 = _Tag___get_tag__impl__7z9hd6(tag);
      tmp_1 = charSequenceLength(this_0) > 0;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      sb.q(this.kv9(tag)).q(' ');
    }
    sb.q(_Message___get_message__impl__3t69n4(message));
    return sb.toString();
  }
  initMetadataForInterface(MessageStringFormatter, 'MessageStringFormatter');
  initMetadataForObject(DefaultFormatter, 'DefaultFormatter', VOID, VOID, [MessageStringFormatter]);
  initMetadataForClass(Tag, 'Tag');
  initMetadataForClass(Severity, 'Severity', VOID, Enum);
  initMetadataForClass(ConsoleWriter, 'ConsoleWriter', ConsoleWriter_init_$Create$, LogWriter);
  initMetadataForClass(JsMutableLoggerConfig, 'JsMutableLoggerConfig');
  initMetadataForObject(ConsoleActual, 'ConsoleActual');
  //endregion
  function get_DEFAULT_MIN_SEVERITY() {
    _init_properties_BaseLogger_kt__lobnq7();
    return DEFAULT_MIN_SEVERITY;
  }
  var DEFAULT_MIN_SEVERITY;
  function BaseLogger(config) {
    this.av9_1 = config;
  }
  protoOf(BaseLogger).ebw = function () {
    return this.av9_1;
  };
  protoOf(BaseLogger).bv9 = function (severity, tag, throwable, message) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.ebw().cv9().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      if (element.ev9(tag, severity)) {
        element.dv9(severity, message, tag, throwable);
      }
    }
  };
  var properties_initialized_BaseLogger_kt_e6qv19;
  function _init_properties_BaseLogger_kt__lobnq7() {
    if (!properties_initialized_BaseLogger_kt_e6qv19) {
      properties_initialized_BaseLogger_kt_e6qv19 = true;
      DEFAULT_MIN_SEVERITY = Severity_Verbose_getInstance();
    }
  }
  function CommonWriter(messageStringFormatter) {
    messageStringFormatter = messageStringFormatter === VOID ? DefaultFormatter_instance : messageStringFormatter;
    LogWriter.call(this);
    this.fv9_1 = messageStringFormatter;
  }
  protoOf(CommonWriter).dv9 = function (severity, message, tag, throwable) {
    println(this.fv9_1.gv9(severity, _Tag___init__impl__opaqzl(tag), _Message___init__impl__p3e8y6(message)));
    if (throwable == null)
      null;
    else {
      printStackTrace(throwable);
    }
  };
  function LogWriter() {
  }
  protoOf(LogWriter).ev9 = function (tag, severity) {
    return true;
  };
  function loggerConfigInit(logWriters, minSeverity) {
    minSeverity = minSeverity === VOID ? get_DEFAULT_MIN_SEVERITY() : minSeverity;
    var tmp0_logWriterList = toList(logWriters);
    return new StaticConfig(minSeverity, tmp0_logWriterList);
  }
  function StaticConfig(minSeverity, logWriterList) {
    minSeverity = minSeverity === VOID ? get_DEFAULT_MIN_SEVERITY() : minSeverity;
    logWriterList = logWriterList === VOID ? listOf(new CommonWriter()) : logWriterList;
    this.hv9_1 = minSeverity;
    this.iv9_1 = logWriterList;
  }
  protoOf(StaticConfig).cv9 = function () {
    return this.iv9_1;
  };
  protoOf(StaticConfig).toString = function () {
    return 'StaticConfig(minSeverity=' + this.hv9_1.toString() + ', logWriterList=' + toString(this.iv9_1) + ')';
  };
  protoOf(StaticConfig).hashCode = function () {
    var result = this.hv9_1.hashCode();
    result = imul(result, 31) + hashCode(this.iv9_1) | 0;
    return result;
  };
  protoOf(StaticConfig).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StaticConfig))
      return false;
    var tmp0_other_with_cast = other instanceof StaticConfig ? other : THROW_CCE();
    if (!this.hv9_1.equals(tmp0_other_with_cast.hv9_1))
      return false;
    if (!equals(this.iv9_1, tmp0_other_with_cast.iv9_1))
      return false;
    return true;
  };
  function MessageStringFormatter() {
  }
  function DefaultFormatter() {
  }
  var DefaultFormatter_instance;
  function DefaultFormatter_getInstance() {
    return DefaultFormatter_instance;
  }
  function _Tag___init__impl__opaqzl(tag) {
    return tag;
  }
  function _Tag___get_tag__impl__7z9hd6($this) {
    return $this;
  }
  function Tag__toString_impl_tvevk7($this) {
    return 'Tag(tag=' + $this + ')';
  }
  function Tag__hashCode_impl_848yrc($this) {
    return getStringHashCode($this);
  }
  function Tag__equals_impl_6ocp5g($this, other) {
    if (!(other instanceof Tag))
      return false;
    if (!($this === (other instanceof Tag ? other.lv9_1 : THROW_CCE())))
      return false;
    return true;
  }
  function Tag(tag) {
    this.lv9_1 = tag;
  }
  protoOf(Tag).toString = function () {
    return Tag__toString_impl_tvevk7(this.lv9_1);
  };
  protoOf(Tag).hashCode = function () {
    return Tag__hashCode_impl_848yrc(this.lv9_1);
  };
  protoOf(Tag).equals = function (other) {
    return Tag__equals_impl_6ocp5g(this.lv9_1, other);
  };
  function _Message___init__impl__p3e8y6(message) {
    return message;
  }
  function _Message___get_message__impl__3t69n4($this) {
    return $this;
  }
  var Severity_Verbose_instance;
  var Severity_Debug_instance;
  var Severity_Info_instance;
  var Severity_Warn_instance;
  var Severity_Error_instance;
  var Severity_Assert_instance;
  var Severity_entriesInitialized;
  function Severity_initEntries() {
    if (Severity_entriesInitialized)
      return Unit_instance;
    Severity_entriesInitialized = true;
    Severity_Verbose_instance = new Severity('Verbose', 0);
    Severity_Debug_instance = new Severity('Debug', 1);
    Severity_Info_instance = new Severity('Info', 2);
    Severity_Warn_instance = new Severity('Warn', 3);
    Severity_Error_instance = new Severity('Error', 4);
    Severity_Assert_instance = new Severity('Assert', 5);
  }
  function Severity(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Severity_Verbose_getInstance() {
    Severity_initEntries();
    return Severity_Verbose_instance;
  }
  function Severity_Debug_getInstance() {
    Severity_initEntries();
    return Severity_Debug_instance;
  }
  function Severity_Info_getInstance() {
    Severity_initEntries();
    return Severity_Info_instance;
  }
  function Severity_Warn_getInstance() {
    Severity_initEntries();
    return Severity_Warn_instance;
  }
  function Severity_Error_getInstance() {
    Severity_initEntries();
    return Severity_Error_instance;
  }
  function Severity_Assert_getInstance() {
    Severity_initEntries();
    return Severity_Assert_instance;
  }
  function ConsoleWriter_init_$Init$(messageStringFormatter, $this) {
    messageStringFormatter = messageStringFormatter === VOID ? DefaultFormatter_instance : messageStringFormatter;
    ConsoleWriter.call($this, messageStringFormatter, ConsoleActual_instance);
    return $this;
  }
  function ConsoleWriter_init_$Create$(messageStringFormatter) {
    return ConsoleWriter_init_$Init$(messageStringFormatter, objectCreate(protoOf(ConsoleWriter)));
  }
  function ConsoleWriter(messageStringFormatter, console) {
    LogWriter.call(this);
    this.mv9_1 = messageStringFormatter;
    this.nv9_1 = console;
  }
  protoOf(ConsoleWriter).dv9 = function (severity, message, tag, throwable) {
    var output = this.mv9_1.gv9(null, _Tag___init__impl__opaqzl(tag), _Message___init__impl__p3e8y6(message));
    if (throwable == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      output = output + (' ' + stackTraceToString(throwable));
    }
    switch (severity.a1_1) {
      case 5:
      case 4:
        this.nv9_1.ls4(output);
        break;
      case 3:
        this.nv9_1.fs5(output);
        break;
      case 2:
        this.nv9_1.ov9(output);
        break;
      case 1:
      case 0:
        this.nv9_1.pv9(output);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  };
  function JsMutableLoggerConfig(logWriters) {
    this.qv9_1 = get_DEFAULT_MIN_SEVERITY();
    this.rv9_1 = logWriters;
  }
  protoOf(JsMutableLoggerConfig).cv9 = function () {
    return this.rv9_1;
  };
  function mutableLoggerConfigInit(logWriters) {
    return new JsMutableLoggerConfig(logWriters);
  }
  function platformLogWriter(messageStringFormatter) {
    messageStringFormatter = messageStringFormatter === VOID ? DefaultFormatter_instance : messageStringFormatter;
    return ConsoleWriter_init_$Create$(messageStringFormatter);
  }
  function ConsoleActual() {
  }
  protoOf(ConsoleActual).ls4 = function (output) {
    console.error(output);
  };
  protoOf(ConsoleActual).fs5 = function (output) {
    console.warn(output);
  };
  protoOf(ConsoleActual).ov9 = function (output) {
    console.info(output);
  };
  protoOf(ConsoleActual).pv9 = function (output) {
    console.log(output);
  };
  var ConsoleActual_instance;
  function ConsoleActual_getInstance() {
    return ConsoleActual_instance;
  }
  //region block: post-declaration
  protoOf(DefaultFormatter).jv9 = formatSeverity;
  protoOf(DefaultFormatter).kv9 = formatTag;
  protoOf(DefaultFormatter).gv9 = formatMessage;
  //endregion
  //region block: init
  DefaultFormatter_instance = new DefaultFormatter();
  ConsoleActual_instance = new ConsoleActual();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = BaseLogger;
  _.$_$.b = loggerConfigInit;
  _.$_$.c = mutableLoggerConfigInit;
  _.$_$.d = platformLogWriter;
  _.$_$.e = Severity_Assert_getInstance;
  _.$_$.f = Severity_Debug_getInstance;
  _.$_$.g = Severity_Error_getInstance;
  _.$_$.h = Severity_Info_getInstance;
  _.$_$.i = Severity_Warn_getInstance;
  //endregion
  return _;
}));

//# sourceMappingURL=Kermit-kermit-core.js.map
